import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=16a3cbbc&scoped=true"
import script from "./dispose.vue?vue&type=script&lang=js"
export * from "./dispose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3cbbc",
  null
  
)

export default component.exports